/** Sample values for template print preview (matches LTL manifest example layout). */
export const MANIFEST_SAMPLE_DATA = {
  manifest_number: 'M-2026-000124',
  shipment_date: 'May 28, 2026',
  carrier_name: 'ABC Freight Lines',
  carrier_scac: 'ABFL',
  pro_number: '987654321',
  bol_number: 'BOL-2026-00589',
  trailer_number: 'TRL-45219',
  seal_number: 'SL-883920',
  driver_name: 'Michael Johnson',
  driver_phone: '555-014-2298',
  pickup_type: 'LTL',
  service_level: 'Standard',
  freight_terms: 'Prepaid',
  payment_terms: 'Third Party Billing',

  shipper_name: 'Orlando Distribution Warehouse',
  shipper_address: '2500 Commerce Park Drive',
  shipper_city_state_zip: 'Orlando, FL 32824',
  shipper_contact: 'Sarah Miller',
  shipper_phone: '555-010-1188',
  shipper_email: 'shipping@orlandowarehouse.example',

  consignee_name: 'Atlanta Retail Supply Center',
  consignee_address: '780 Industrial Parkway',
  consignee_city_state_zip: 'Atlanta, GA 30336',
  consignee_contact: 'David Reynolds',
  consignee_phone: '555-016-4450',
  consignee_email: 'receiving@atlantasupply.example',

  bill_to_name: 'National Logistics Group',
  bill_to_address: '100 Corporate Plaza',
  bill_to_city_state_zip: 'Charlotte, NC 28202',
  bill_to_account: 'NLG-458210',
  bill_to_phone: '555-012-8844',

  freight_lines: [
    {
      line: 1,
      handling_unit: 2,
      pieces: 48,
      package_type: 'Cartons on Pallets',
      description: 'Packaged retail merchandise',
      nmfc: '156600',
      freight_class: '70',
      weight: '1,250 lbs',
      dimensions: '48 x 40 x 60 in each',
    },
    {
      line: 2,
      handling_unit: 1,
      pieces: 12,
      package_type: 'Cartons on Pallet',
      description: 'Replacement parts, NOI',
      nmfc: '178690',
      freight_class: '85',
      weight: '625 lbs',
      dimensions: '48 x 40 x 48 in',
    },
    {
      line: 3,
      handling_unit: 1,
      pieces: 8,
      package_type: 'Cartons on Pallet',
      description: 'Display fixtures',
      nmfc: '164390',
      freight_class: '125',
      weight: '410 lbs',
      dimensions: '60 x 48 x 52 in',
    },
  ],
  total_handling_units: '4 pallets',
  total_pieces: '68 cartons',
  total_weight: '2,285 lbs',
  total_cube: '282 cu. ft.',
  hazmat: 'No',
  temp_controlled: 'No',
  stackable: 'Yes, except line 3',
  liftgate_required: 'No',
  inside_delivery: 'No',

  pickup_date: 'May 28, 2026',
  pickup_window: '1:00 PM – 4:00 PM',
  pickup_location_type: 'Commercial warehouse',
  dock_available: 'Yes',
  pickup_instructions:
    'Check in at guard gate. Reference BOL-2026-00589. Driver must wear safety vest in loading area.',

  estimated_delivery_date: 'May 30, 2026',
  delivery_window: '8:00 AM – 3:00 PM',
  delivery_location_type: 'Commercial receiving dock',
  appointment_required: 'Yes',
  delivery_appointment_number: 'APPT-77341',
  delivery_instructions:
    'Deliver to Dock Door 6. Call receiving office 30 minutes before arrival.',

  reference_numbers: [
    { type: 'Customer PO', number: 'PO-784512' },
    { type: 'Sales Order', number: 'SO-102884' },
    { type: 'Warehouse Load ID', number: 'LOAD-55602' },
    { type: 'Carrier Pickup Request', number: 'CPU-331980' },
    { type: 'Consignee Reference', number: 'ATL-RCV-2026-221' },
  ],

  accessorials: [
    { name: 'Liftgate Pickup', required: 'No' },
    { name: 'Liftgate Delivery', required: 'No' },
    { name: 'Residential Delivery', required: 'No' },
    { name: 'Inside Delivery', required: 'No' },
    { name: 'Appointment Delivery', required: 'Yes' },
    { name: 'Notify Before Delivery', required: 'Yes' },
    { name: 'Limited Access', required: 'No' },
  ],

  certification_text:
    'This manifest represents the freight tendered to the carrier for domestic LTL transportation. Freight count, weight, classification, and condition are subject to carrier inspection and confirmation.',
  shipper_signature_name: 'Sarah Miller',
  shipper_signature_date: 'May 28, 2026',
  driver_signature_name: 'Michael Johnson',
  driver_signature_date: 'May 28, 2026',
};
